import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Pages
import LandingPage from './pages/LandingPage';
import HomePageRedesign from './pages/HomePageRedesign';
import AboutPage from './pages/AboutPage';
import AppReleasePage from './pages/AppReleasePage';
import NotFoundPage from './pages/NotFoundPage';
import PricingPage from './pages/PricingPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import DownloadPage from './pages/DownloadPage';
import GetAppPage from './pages/GetAppPage';
import ScreenshotsPage from './pages/ScreenshotsPage';

// Components
import AppLinkRedirect from './components/AppLinkRedirect';

// Context Providers
import { ThemeProvider } from './theme';

// SEO Component
import SEO from './components/common/SEO';

function App() {
  return (
    <ThemeProvider>
      <Router>
            {/* Default SEO settings for the entire application */}
          <SEO />
          <Routes>
            <Route path="/" element={<LandingPage track="danish" />} />
            <Route path="/learn-danish" element={<LandingPage track="danish" />} />
            <Route path="/learn-english" element={<LandingPage track="english" />} />
            <Route path="/home" element={<LandingPage />} />
            <Route path="/old-home" element={<LandingPage />} />
            <Route path="/old-home-v1" element={<HomePageRedesign />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/app-release" element={<AppReleasePage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            <Route path="/download" element={<DownloadPage />} />
            <Route path="/get" element={<GetAppPage />} />
            <Route path="/screenshots" element={<ScreenshotsPage />} />
            <Route path="/applink/*" element={<AppLinkRedirect />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
